export enum CmContractInlineObjectViewTypeUiEnum {
    standard,
    object
}